import React, { useState } from 'react'

const ReadMoreHtml = ({ html, min = 400 }) => {
    const [expanded, setExpanded] = useState(false)

    const shortHtml = html.slice(0, min)

    return (
        <div className="auctDesction">
            <div
                dangerouslySetInnerHTML={{
                    __html: expanded ? html : shortHtml + (html.length > min ? '...' : ''),
                }}
            />
            {html.length > min && (
                <span
                    className="read-more-link"
                    onClick={() => setExpanded(!expanded)}
                    style={{
                        color: '#007bff',
                        cursor: 'pointer',
                        marginTop: 8,
                        display: 'inline-block',
                        fontSize: 14,
                        fontWeight: 500,
                    }}
                >
                    {expanded ? 'SHOW LESS' : 'SHOW MORE'}
                </span>
            )}
        </div>
    )
}

export default ReadMoreHtml
